import { useCallback, useState } from 'react';

export const useQuickEntry = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [activeEntity, setActiveEntity] = useState(null);

  const openDialog = useCallback(() => setIsDialogOpen(true), []);
  const closeDialog = useCallback(() => setIsDialogOpen(false), []);
  const closeDrawer = useCallback(() => setActiveEntity(null), []);

  const selectEntity = useCallback(({ entity }) => {
    setActiveEntity(entity);
    setIsDialogOpen(false);
  }, []);

  return {
    activeEntity,
    closeDialog,
    closeDrawer,
    isDialogOpen,
    openDialog,
    selectEntity
  };
};
